<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-sms__signcoupon">

            <el-dialog title="签到记录" :visible.sync="SincouponDetailVisable">
                <el-table :data="gridData">
                    <el-table-column property="memberName" label="姓名" width="200"></el-table-column>
                    <el-table-column property="createTime" label="签到日期"></el-table-column>
<!--                    <el-table-column property="address" label="地址"></el-table-column>-->
                </el-table>
            </el-dialog>


            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item v-if="visible">
                    <el-select v-model="dataForm.orgId" placeholder="请选择区域">
                        <el-option label="全选" value="" key=""></el-option>
                        <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.orgName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.mobileNumber" placeholder="会员电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
                </el-form-item>
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('sms:signcoupon:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
                <!--        </el-form-item>-->
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('sms:signcoupon:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
                <!--        </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <!--        <el-table-column prop="id" label="" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="memberId" label="用户id" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="orgName" label="公司名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobileNumber" label="会员电话号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="count" label="总签到次数" header-align="center" align="center"></el-table-column>
                <el-table-column prop="amount" label="优惠卷当前余额" header-align="center" align="center"></el-table-column>
                <el-table-column prop="continuousTime" label="连续签到次数" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="updateTime" label="上一次签到时间" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <!--            <el-button v-if="$hasPermission('sms:signcoupon:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>-->
                        <!--                        <el-button v-if="$hasPermission('sms:signcoupon:update')" type="text" size="small"-->
                        <!--                                   @click="SincouponDetailMsg(scope.row.memberId)">详情-->
                        <!--                        </el-button>-->
                        <el-button type="text" @click="getDetailMsg(scope.row.memberId)">详情</el-button>
                        <!--            <el-button v-if="$hasPermission('sms:signcoupon:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './signcoupon-add-or-update'
    import SincouponDetail from './signcoupon-detail'

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                SincouponDetailVisable: false,
                visible: false,
                orgList: [],
                mixinViewModuleOptions: {
                    getDataListURL: '/sms/signcoupon/page',
                    getDataListIsPage: true,
                    exportURL: '/sms/signcoupon/export',
                    deleteURL: '/sms/signcoupon',
                    deleteIsBatch: true,
                    activatedIsNeed: false
                },
                gridData: [{
                    createTime: '',
                    id: '',
                    memberId: '',
                    memberName: ''
                }],
                dialogTableVisible: false,
                dataForm: {
                    mobileNumber: '',
                    memberName: '',
                    beginDate: "",
                    endDate: "",
                    verifyStatus: '',
                    orgId: '',
                    orgName:'',
                    isHead:false
                }
            }
        },
        mounted() {
            const that = this;
            that.getInfo();
        },
        components: {
            AddOrUpdate,
            SincouponDetail
        },
        methods: {
            getInfo() {
                this.$http.get(`/sys/user/info`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.orgId=res.data.orgId
                    this.dataForm.orgName=res.data.orgName
                    this.dataForm.isHead=res.data.isHead;
                    if (this.dataForm.isHead) {
                        this.visible=true;
                        this.getOrgList();
                    }
                    if(!this.mixinViewModuleOptions.activatedIsNeed){
                        this.getDataList()
                    }
                }).catch(() => {
                })
            },
            // 获取部门列表
            getOrgList() {
                return this.$http.get('/sys/org/select').then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.orgList = res.data
                }).catch(() => {
                })
            },
            getDetailMsg(memberId) {
                this.SincouponDetailVisable = true
                this.$http.get(`/sms/signcoupon/getHistory/${memberId}`).then(({data: res}) => {
                    console.log(res)
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.gridData = res.data
                    console.info(this.gridData)
                }).catch(() => {
                })
            }
        }
    }
</script>
